// Generated by script, don't edit it please.
import createSvgIcon from '../../createSvgIcon';
import AngleLeftSvg from '@rsuite/icon-font/lib/legacy/AngleLeft';
var AngleLeft = createSvgIcon({
    as: AngleLeftSvg,
    ariaLabel: 'angle left',
    category: 'legacy',
    displayName: 'AngleLeft'
});
export default AngleLeft;
